module.exports = __webpack_public_path__ + "img/icon-home.9ead91d1.svg";